export const state = () => ({
  data: '',
  choices: undefined,
  tempSearchInput: '',
});

export const mutations = {
  SET_TEMP_SEARCH_INPUT(state, value) {
    state.tempSearchInput = value;
  },
  SET_DATA(state, data) {
    state.data = data;
  },
  CLEAN(state) {
    state.data = '';
  },
  SET_CHOICES(state, choices) {
    state.choices = choices;
  },
  CLEAR_CHOICES(state) {
    state.choices = [];
  },
};

export const getters = {
  getQuery(state) {
    if (state.data) {
      return { q: state.data };
    }
    return {};
  },
};

export const actions = {
  setData({ commit }, data) {
    commit('SET_DATA', data);
  },
  setDataFromQuery({ commit }, { q }) {
    if (q) {
      commit('SET_DATA', q);
    } else {
      commit('SET_DATA', '');
    }
  },
  setChoices({ commit }) {},
  clearChoices({ commit }) {
    commit('CLEAR_CHOICES');
  },
  async fetchChoices({ commit }, query) {
    if (query.q) {
      try {
        const { data } = await this.$HTTP.quickSearch(query);
        commit('SET_CHOICES', data.results);
      } catch (e) {
        return Promise.reject(e);
      }
    } else {
      commit('CLEAR_CHOICES');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
